import {
    ResponseStatus,
    TypeOfFinalTransaction,
    ErrorCodes
} from "../dtos/KioskDtos.dtos";
import { put, select } from "redux-saga/effects";
import { showErrorUpdateMessage } from "../store/Errors/actions";
import TimerManager from "../services/TimerManager";
import { eraseAllStoreData } from "../store";

import { Routes } from "../constants/routes";
import { authenticateUser } from "../store/Login/actions";
import { getTextLibraryForSaga } from "../store/LanguageLocale/selector";
import { LanguageLocaleService } from "../services/Language/LanguageService";
import { LanguageCodes } from "../constants/languages";
import { redirectToSurvey } from "./surveyRedirectSaga";
import { HttpStatusCode } from "../constants/HttpStatusCodes";
import { push } from "../store/Routing/actions";

import { debugDispatchSaga } from "./debugDispatchSaga";

export function* errorHandlerSaga(e: { responseStatus: ResponseStatus }) {
    yield debugDispatchSaga("Error Encountered", true, e);
    if (HttpStatusCode[e.responseStatus.errorCode] === HttpStatusCode.Unauthorized) {
        const textLibrary: LanguageLocaleService = yield select(getTextLibraryForSaga);
        const textString = textLibrary
            ? textLibrary
                .setAndGetCurrentLanguageResource(navigator.language.substring(0, 2) as LanguageCodes)
                .getGeneralStrings()
                .messagesInstructions
                .UnauthorizedAccessMessage
            : "Error. Erreur.";
        // Show native simple alert and reload application.
        yield alert(textString);
        window.location.reload();
    } else if (e.responseStatus && e.responseStatus.errorCode) {
        if (Object.values(ErrorCodes).includes(e.responseStatus.errorCode)) {
            yield put(redirectToSurvey(showErrorUpdateMessage(true, ErrorCodes[e.responseStatus.errorCode], true), TypeOfFinalTransaction.EncounteredError, ErrorCodes[e.responseStatus.errorCode]));
        } else {
            yield put(showErrorUpdateMessage(true, ErrorCodes.None, true));
        }
    } else {
        yield TimerManager.stopInactivityListener();
        yield put(eraseAllStoreData());
        yield put(push(Routes.root))
        yield put(authenticateUser(false));
    }
}

export function* expectedErrorHandlerSaga(errorCode: ErrorCodes) {
    yield debugDispatchSaga("Expected Error Encountered", false, ErrorCodes[errorCode]);
    if (Object.values(ErrorCodes).includes(errorCode)) {
        yield put(redirectToSurvey(showErrorUpdateMessage(true, errorCode, true), TypeOfFinalTransaction.EncounteredError, errorCode));
    } else {
        yield put(showErrorUpdateMessage(true, ErrorCodes.None, true));
    }
}


// WEBPACK FOOTER //
// ./src/sagas/errorSaga.ts